// extracted by mini-css-extract-plugin
export default {"Recipient":"styles_Recipient__9a07T","rounded":"styles_rounded__1fS4Q","noAvatar":"styles_noAvatar__IjOrs","name":"styles_name__Gq-KE"};